import type { QuotePrintVariant } from '@efacture/core/sales';
import { isDesktopApp } from './desktop';

export interface QuotePrintAction {
  variant: QuotePrintVariant;
  label: string;
}

export interface QuoteWording {
  /** Sidebar entry. */
  menu: string;
  listTitle: string;
  newLabel: string;
  formTitleNew: string;
  formTitleEdit: string;
  draftTitle: string;
  printActions: QuotePrintAction[];
}

const QUOTE_WORDING: QuoteWording = {
  menu: 'Devis',
  listTitle: 'Devis / proformas',
  newLabel: 'Nouveau devis',
  formTitleNew: 'Nouveau devis',
  formTitleEdit: 'Modifier le devis',
  draftTitle: 'Brouillon de devis',
  printActions: [
    { variant: 'DEVIS', label: 'Imprimer le devis' },
    { variant: 'PROFORMA', label: 'Imprimer la facture proforma' },
  ],
};

/** The desktop edition labels every quote « Pro-forma »; the printed title is chosen by the API. */
const DESKTOP_PRO_FORMA_WORDING: QuoteWording = {
  menu: 'Pro-forma',
  listTitle: 'Pro-forma',
  newLabel: 'Nouveau pro-forma',
  formTitleNew: 'Nouveau pro-forma',
  formTitleEdit: 'Modifier le pro-forma',
  draftTitle: 'Brouillon de pro-forma',
  printActions: [{ variant: 'PROFORMA', label: 'Imprimer le pro-forma' }],
};

export function quoteWording(desktop: boolean): QuoteWording {
  return desktop ? DESKTOP_PRO_FORMA_WORDING : QUOTE_WORDING;
}

/** Wording of the quote screens for this edition. */
export function useQuoteWording(): QuoteWording {
  return quoteWording(isDesktopApp());
}
